import QuestionarioQuestao from './QuestionarioQuestao';

/**
 * Objeto que representa uma seção do questionário
 */
class QuestionarioSecao {
    
    /**
     * Cria uma nova instância de uma seção
     * Caso os parâmetros não sejam informados, cria com as propriedades vazias
     * 
     * @param {Number|null} id Id da seção na API
     * @param {String|null} titulo Título da seção
     * @param {Number|null} ordem Ordem da seção no questionário
     * @param {Array<QuestionarioQuestao>|null} questoes Questões relacionadas à seção
     */
    constructor (id, titulo, ordem, questoes) {
        /** @member {number} id Id da seção na API */
        this.id = id ?? null;
        /** @member {string} titulo Título da seção */
        this.titulo = titulo ?? '';
        /** @member {boolean} ordem Ordem da seção no questionário */
        this.ordem = ordem ?? 1;
        /** @member {Array<QuestionarioQuestao>|null} questoes Questões relacionadas à seção */
        this.questoes = questoes ?? [];
    }

    /**
     * Cria uma cópia do objeto
     * @param {QuestionarioSecao} origem Objeto a ser copiado
     * @returns {QuestionarioSecao} Novo objeto com os mesmos valores que o original
     */
    static clone(origem) {
        //Copia a lista de seções
        let questoes = null;
        if (origem.questoes)
            questoes = origem.questoes.map(questao => QuestionarioQuestao.clone(questao));
        //Cria um novo objeto com os mesmos valores
        return new QuestionarioSecao(origem.id, origem.titulo, origem.ordem, questoes);
    }

    /**
     * Compara duas seções do questionário, retornando verdadeiro se elas forem iguais
     * @param {QuestionarioSecao} obj1 Primeiro objeto a ser comparado
     * @param {QuestionarioSecao} obj2 Segundo objeto a ser comparado
     * @returns {Boolean} Retorna verdadeiro se os dois objetos forem iguais
     */
    static compare(obj1, obj2) {
        //Se os dois possuírem o mesmo endereço de memória
        if (obj1 === obj2)
            return true;
        //Se um dos dois for nulo
        if (!obj1 || !obj2)
            return false;
        //Compara as propriedades
        let result = obj1.id === obj2.id
                  && obj1.titulo === obj2.titulo
                  && obj1.ordem === obj2.ordem;
        
        //Caso as propriedades sejam iguais, verifica as listas
        if (result) {
            return QuestionarioSecao.compareQuestions(obj1.questoes, obj2.questoes);
        } else {
            return false;
        }
    }

    /**
     * Compara a lista de questões das seções
     * @param {Array<QuestionarioQuestao>} qst1 Lista de questões da primeira seção
     * @param {Array<QuestionarioQuestao>} qst2 Lista de questões da segunda seção
     * @returns {Boolean} Retorna verdadeiro se os itens das duas listas forem iguais
     */
    static compareQuestions(qst1, qst2) {
        //Se as duas listas possuírem o mesmo endereço de memória
        if (qst1 === qst2)
            return true;
        //Se uma das duas for nula
        if (!qst1 || !qst2)
            return false;
        //Se os tamanhos forem diferentes
        if (qst1.length !== qst2.length)
            return false;
        //Verifica se existe algum item que seja diferente entre as listas
        for (let i = 0; i < qst1.length; i++) {
            if (!QuestionarioQuestao.compare(qst1[i], qst2[i]))
                return false;
        }
        return true;
    }

}

export default QuestionarioSecao;